import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d8a8f054 = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _74569d52 = () => interopDefault(import('../pages/become-an-author/index.vue' /* webpackChunkName: "pages/become-an-author/index" */))
const _72ceb043 = () => interopDefault(import('../pages/brokers/index.vue' /* webpackChunkName: "pages/brokers/index" */))
const _65b7cf44 = () => interopDefault(import('../pages/company-compare/index.vue' /* webpackChunkName: "pages/company-compare/index" */))
const _0cce6818 = () => interopDefault(import('../pages/contact-us/index.vue' /* webpackChunkName: "pages/contact-us/index" */))
const _6b0aac51 = () => interopDefault(import('../pages/contributor-confirmation.vue' /* webpackChunkName: "pages/contributor-confirmation" */))
const _74c9a8d8 = () => interopDefault(import('../pages/cookies/index.vue' /* webpackChunkName: "pages/cookies/index" */))
const _7c98cadd = () => interopDefault(import('../pages/EconomicCalendar.vue' /* webpackChunkName: "pages/EconomicCalendar" */))
const _72ab830e = () => interopDefault(import('../pages/Education.vue' /* webpackChunkName: "pages/Education" */))
const _37296ece = () => interopDefault(import('../pages/forgot-password/index.vue' /* webpackChunkName: "pages/forgot-password/index" */))
const _1c1ec8a8 = () => interopDefault(import('../pages/live-feed/index.vue' /* webpackChunkName: "pages/live-feed/index" */))
const _b389bca4 = () => interopDefault(import('../pages/LiveCharts/index.vue' /* webpackChunkName: "pages/LiveCharts/index" */))
const _50180c50 = () => interopDefault(import('../pages/LiveQuotes/index.vue' /* webpackChunkName: "pages/LiveQuotes/index" */))
const _71071aa0 = () => interopDefault(import('../pages/premium/index.vue' /* webpackChunkName: "pages/premium/index" */))
const _753932de = () => interopDefault(import('../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _d5f21fa2 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _4bb7511c = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _48f0bcdf = () => interopDefault(import('../pages/profile/following-preferences/index.vue' /* webpackChunkName: "pages/profile/following-preferences/index" */))
const _14124ce6 = () => interopDefault(import('../pages/profile/my-companies/index.vue' /* webpackChunkName: "pages/profile/my-companies/index" */))
const _2ab8c895 = () => interopDefault(import('../pages/profile/my-contributions/index.vue' /* webpackChunkName: "pages/profile/my-contributions/index" */))
const _bde2cb68 = () => interopDefault(import('../pages/profile/my-companies/add-company.vue' /* webpackChunkName: "pages/profile/my-companies/add-company" */))
const _437b654c = () => interopDefault(import('../pages/profile/my-contributions/edit/index.vue' /* webpackChunkName: "pages/profile/my-contributions/edit/index" */))
const _eec3b0ac = () => interopDefault(import('../pages/profile/my-contributions/edit/_articleSlug.vue' /* webpackChunkName: "pages/profile/my-contributions/edit/_articleSlug" */))
const _61ea1884 = () => interopDefault(import('../pages/profile/my-companies/_category/_company/edit.vue' /* webpackChunkName: "pages/profile/my-companies/_category/_company/edit" */))
const _54cc4b94 = () => interopDefault(import('../pages/reactivation/index.vue' /* webpackChunkName: "pages/reactivation/index" */))
const _0d6930f4 = () => interopDefault(import('../pages/reset-password/index.vue' /* webpackChunkName: "pages/reset-password/index" */))
const _2441afdb = () => interopDefault(import('../pages/rss/index.vue' /* webpackChunkName: "pages/rss/index" */))
const _1657b604 = () => interopDefault(import('../pages/search-results/index.vue' /* webpackChunkName: "pages/search-results/index" */))
const _4a5a32c0 = () => interopDefault(import('../pages/SessionWraps/index.vue' /* webpackChunkName: "pages/SessionWraps/index" */))
const _8941c578 = () => interopDefault(import('../pages/sign-up-confirmation/index.vue' /* webpackChunkName: "pages/sign-up-confirmation/index" */))
const _69705276 = () => interopDefault(import('../pages/SignUp/index.vue' /* webpackChunkName: "pages/SignUp/index" */))
const _537eade5 = () => interopDefault(import('../pages/sponsored-contributor-confirmation.vue' /* webpackChunkName: "pages/sponsored-contributor-confirmation" */))
const _500e56e6 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _44b60560 = () => interopDefault(import('../pages/terms/index.vue' /* webpackChunkName: "pages/terms/index" */))
const _a3dd727a = () => interopDefault(import('../pages/terms/search-results.vue' /* webpackChunkName: "pages/terms/search-results" */))
const _f98f3a7a = () => interopDefault(import('../pages/terms/_letter.vue' /* webpackChunkName: "pages/terms/_letter" */))
const _89dae9f4 = () => interopDefault(import('../pages/terms/_letter/index.vue' /* webpackChunkName: "pages/terms/_letter/index" */))
const _abb10a02 = () => interopDefault(import('../pages/terms/_letter/_term.vue' /* webpackChunkName: "pages/terms/_letter/_term" */))
const _b957b678 = () => interopDefault(import('../pages/terms-of-use/index.vue' /* webpackChunkName: "pages/terms-of-use/index" */))
const _497a1270 = () => interopDefault(import('../pages/Tag/search-results.vue' /* webpackChunkName: "pages/Tag/search-results" */))
const _ba03e03e = () => interopDefault(import('../pages/auth/google/callback/index.vue' /* webpackChunkName: "pages/auth/google/callback/index" */))
const _c49eece0 = () => interopDefault(import('../pages/author/_author.vue' /* webpackChunkName: "pages/author/_author" */))
const _70914b20 = () => interopDefault(import('../pages/brokers/_company/index.vue' /* webpackChunkName: "pages/brokers/_company/index" */))
const _455d8326 = () => interopDefault(import('../pages/LiveQuotes/_asset/index.vue' /* webpackChunkName: "pages/LiveQuotes/_asset/index" */))
const _68cefc3a = () => interopDefault(import('../pages/Tag/_tag.vue' /* webpackChunkName: "pages/Tag/_tag" */))
const _f9fd6206 = () => interopDefault(import('../pages/brokers/_company/review/index.vue' /* webpackChunkName: "pages/brokers/_company/review/index" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _1e6ca7a6 = () => interopDefault(import('../pages/_category/index.vue' /* webpackChunkName: "pages/_category/index" */))
const _51360056 = () => interopDefault(import('../pages/_category/_article/index.vue' /* webpackChunkName: "pages/_category/_article/index" */))
const _385003cb = () => interopDefault(import('../pages/_category/_article/amp/index.vue' /* webpackChunkName: "pages/_category/_article/amp/index" */))
const _4f845bcd = () => interopDefault(import('../pages/_category/_article/index' /* webpackChunkName: "pages/_category/_article/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _d8a8f054,
    name: "about"
  }, {
    path: "/become-an-author",
    component: _74569d52,
    name: "become-an-author"
  }, {
    path: "/brokers",
    component: _72ceb043,
    alias: ["/brokers/page/:number(\\d+)"],
    name: "brokers"
  }, {
    path: "/company-compare",
    component: _65b7cf44,
    name: "company-compare"
  }, {
    path: "/contact-us",
    component: _0cce6818,
    name: "contact-us"
  }, {
    path: "/contributor-confirmation",
    component: _6b0aac51,
    name: "contributor-confirmation"
  }, {
    path: "/cookies",
    component: _74c9a8d8,
    name: "cookies"
  }, {
    path: "/EconomicCalendar",
    component: _7c98cadd,
    name: "EconomicCalendar"
  }, {
    path: "/Education",
    component: _72ab830e,
    alias: ["/Education/page/:number(\\d+)"],
    name: "Education"
  }, {
    path: "/forgot-password",
    component: _37296ece,
    name: "forgot-password"
  }, {
    path: "/live-feed",
    component: _1c1ec8a8,
    alias: ["/live-feed/page/:number(\\d+)"],
    name: "live-feed"
  }, {
    path: "/LiveCharts",
    component: _b389bca4,
    alias: ["/LiveCharts/(/*)"],
    name: "LiveCharts"
  }, {
    path: "/LiveQuotes",
    component: _50180c50,
    alias: ["/LiveQuotes/(/*)"],
    name: "LiveQuotes"
  }, {
    path: "/premium",
    component: _71071aa0,
    name: "premium"
  }, {
    path: "/privacy",
    component: _753932de,
    name: "privacy"
  }, {
    path: "/profile",
    component: _d5f21fa2,
    children: [{
      path: "",
      component: _4bb7511c,
      name: "profile"
    }, {
      path: "following-preferences",
      component: _48f0bcdf,
      name: "profile-following-preferences"
    }, {
      path: "my-companies",
      component: _14124ce6,
      name: "profile-my-companies"
    }, {
      path: "my-contributions",
      component: _2ab8c895,
      name: "profile-my-contributions"
    }, {
      path: "my-companies/add-company",
      component: _bde2cb68,
      name: "profile-my-companies-add-company"
    }, {
      path: "my-contributions/edit",
      component: _437b654c,
      name: "profile-my-contributions-edit"
    }, {
      path: "my-contributions/edit/:articleSlug",
      component: _eec3b0ac,
      name: "profile-my-contributions-edit-articleSlug"
    }, {
      path: "my-companies/:category?/:company/edit",
      component: _61ea1884,
      name: "profile-my-companies-category-company-edit"
    }]
  }, {
    path: "/reactivation",
    component: _54cc4b94,
    name: "reactivation"
  }, {
    path: "/reset-password",
    component: _0d6930f4,
    name: "reset-password"
  }, {
    path: "/rss",
    component: _2441afdb,
    name: "rss"
  }, {
    path: "/search-results",
    component: _1657b604,
    name: "search-results"
  }, {
    path: "/SessionWraps",
    component: _4a5a32c0,
    alias: ["/SessionWraps/page/:number(\\d+)"],
    name: "SessionWraps"
  }, {
    path: "/sign-up-confirmation",
    component: _8941c578,
    name: "sign-up-confirmation"
  }, {
    path: "/SignUp",
    component: _69705276,
    name: "SignUp"
  }, {
    path: "/sponsored-contributor-confirmation",
    component: _537eade5,
    name: "sponsored-contributor-confirmation"
  }, {
    path: "/terms",
    component: _500e56e6,
    children: [{
      path: "",
      component: _44b60560,
      name: "terms"
    }, {
      path: "search-results",
      component: _a3dd727a,
      name: "terms-search-results"
    }, {
      path: ":letter",
      component: _f98f3a7a,
      children: [{
        path: "",
        component: _89dae9f4,
        name: "terms-letter"
      }, {
        path: ":term",
        component: _abb10a02,
        alias: [":term/page/:number(\\d+)"],
        name: "terms-letter-term"
      }]
    }]
  }, {
    path: "/terms-of-use",
    component: _b957b678,
    name: "terms-of-use"
  }, {
    path: "/Tag/search-results",
    component: _497a1270,
    name: "Tag-search-results"
  }, {
    path: "/auth/google/callback",
    component: _ba03e03e,
    name: "auth-google-callback"
  }, {
    path: "/author/:author?",
    component: _c49eece0,
    alias: ["/author/:author?/page/:number(\\d+)"],
    name: "author-author"
  }, {
    path: "/brokers/:company",
    component: _70914b20,
    name: "brokers-company"
  }, {
    path: "/LiveQuotes/:asset",
    component: _455d8326,
    alias: ["/LiveQuotes/:asset/(/*)"],
    name: "LiveQuotes-asset"
  }, {
    path: "/Tag/:tag?",
    component: _68cefc3a,
    alias: ["/Tag/:tag?/page/:number(\\d+)"],
    name: "Tag-tag"
  }, {
    path: "/brokers/:company/review",
    component: _f9fd6206,
    name: "brokers-company-review"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/:category",
    component: _1e6ca7a6,
    alias: ["/:category/page/:number(\\d+)"],
    name: "category"
  }, {
    path: "/:category/:article",
    component: _51360056,
    alias: ["/:category/!/:article/(/*)","/:category/!/:article","/:category/:article/(/*)"],
    name: "category-article"
  }, {
    path: "/:category/:article/amp",
    component: _385003cb,
    alias: ["/:category/!/:article/amp/"],
    name: "category-article-amp"
  }, {
    path: "/:category/:article/:gibberish",
    component: _4f845bcd,
    name: "category-article-gibberish"
  }, {
    path: "/:category/!/:article/:gibberish",
    component: _4f845bcd,
    name: "category-article-migrated-gibberish"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
